import {ApolloClient} from 'apollo-client'
import {HttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import {ApolloLink} from 'apollo-link'
  const loginLink = new HttpLink({
    uri: 'https://api.xiaoyima.work/login'    //请求路径
  })
  


  const loginClient = new ApolloClient({
    link: loginLink,  //如果不添加请求头直接放路径
    cache: new InMemoryCache()
  })
  
  export default loginClient
  


// WEBPACK FOOTER //
// ./src/utils/graphql/logingraphql.js